export default {
  gray:   { stroke: '#2F3547', fill: '#EBEFF3', picker: '#C7D0DB' },
  blue:   { stroke: '#233057', fill: '#D4E0F7', picker: '#B0C5F3' },
  orange: { stroke: '#60351B', fill: '#F8DCCC', picker: '#F5C4A3' },
  red:    { stroke: '#651D2C', fill: '#F5D1D8', picker: '#E79DAC' },
  green:  { stroke: '#0D5643', fill: '#CDEEE2', picker: '#B0E8D2' },
  purple: { stroke: '#352C4E', fill: '#D7D2F2', picker: '#B5ADEB' },
  aqua:   { stroke: '#1C4356', fill: '#C7EAF4', picker: '#A7DDF1' },
  pink:   { stroke: '#582259', fill: '#F3D0F2', picker: '#E6ACEC' }
}
// Old tag colors - keep in case we need to revert - need to confirm with design
// export default {
//   gray:   { stroke: '#5E6678', fill: '#ECEFF3', picker: '#C7D0DB'},
//   blue:   { stroke: '#2C334E', fill: '#E5EAF5', picker: '#B0C5F3'},
//   orange: { stroke: '#533827', fill: '#F3E6DE', picker: '#F5C4A3'},
//   red:    { stroke: '#552A32', fill: '#F0E0E3', picker: '#E79DAC'},
//   green:  { stroke: '#2C4F42', fill: '#E1EFEA', picker: '#B0E8D2'},
//   purple: { stroke: '#352C4E', fill: '#E2E0F0', picker: '#B5ADEB'},
//   aqua:   { stroke: '#2C414E', fill: '#DEEDF3', picker: '#A7DDF1'},
//   pink:   { stroke: '#4C2B50', fill: '#EFDFF1', picker: '#E6ACEC'},
// }
